// Step names that depend on what the agent is working on. Deep research runs on
// companies (by domain) or on people (by LinkedIn), so its name follows the flow:
// a company source makes the records companies until a "find people" step turns
// them into contacts.

const COMPANY_SOURCES = ["source.find_companies", "source.lookalike_companies", "source.from_account_list"];

const prettify = type => String(type || "").split(".").pop().replace(/_/g, " ");

// "company" or "contact": what the records are when they reach this node.
export const subjectAt = (flow, nodeId) => {
  let subject = "contact";
  for (const n of flow || []) {
    if (nodeId && n.nodeId === nodeId) return subject;
    const t = n.stepType || "";
    if (COMPANY_SOURCES.includes(t)) subject = "company";
    else if (t.startsWith("source.") || t.startsWith("expand.")) subject = "contact";
  }
  return subject;
};

const RESEARCH = { company: "Deep-research each company", contact: "Deep-research each contact" };

// The name to show for a step. Pass the agent's flow (and the node, when there is
// one) so the research step says companies or contacts.
export const stepLabel = (type, stepDefs, flow, nodeId) => {
  if (type === "enrich.research" && flow) {
    const node = nodeId || ((flow || []).find(n => n.stepType === type) || {}).nodeId;
    return RESEARCH[subjectAt(flow, node)];
  }
  const d = (stepDefs || []).find(x => x.type === type);
  return (d && d.displayName) || prettify(type);
};
